import clsx from "clsx";
import { MarkdownRenderer } from "../../components/MyMarkdown";

/**
 * AI cevabını gösteren bileşen.
 * Eskiden socket streaming ile chunk chunk doluyordu,
 * artık REST response'tan tek seferde geliyor.
 *
 * NOT: Metni ham HTML olarak basmıyoruz. AI geri bildirimi sık sık
 * <p>, <span>, <div> gibi etiket adları içerir; bunlar dangerouslySetInnerHTML
 * ile basılırsa gerçek (boş) DOM elementi olarak parse edilip ekrandan
 * kaybolur. MarkdownRenderer'a allowHtml={false} ile veriyoruz: etiketler
 * escape edilip olduğu gibi görünür, kod blokları da düzgün render olur.
 */
const AiContent = ({
  aiReply,
  isFocused,
}: {
  aiReply: React.ReactNode;
  setAiReply?: (n: (string | null) | ((prev: string | null) => string)) => void;
  isFocused: boolean;
}) => {
  return aiReply ? (
    <div
      className={clsx(
        "flex flex-col p-8 bg-myGb/10 text-white/90 font-medium practiceTitle",
        isFocused ? "rounded-2xl" : "rounded-b-2xl"
      )}
    >
      <MarkdownRenderer
        content={(aiReply as string).trim()}
        allowHtml={false}
        breaks
      />
    </div>
  ) : null;
};

export default AiContent;
